import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

import { KeyEventUtil } from 'utils'

const ImporteFormGroup = ({
  innerRef,
  iError,
  iTouched,
  fIsSubmitting,
  noIncluyeIgv,
  vCuentaContable,
  vTipoAfectacion,
  vCentroCosto,
  vFlagCentroCosto,
  vCuentaDestino,
  aplicaDestino
}) => {
  const onKeyDown = React.useCallback(
    e => {
      let nextNodeId = 'select-cuentaContable'

      if (vCuentaContable) {
        nextNodeId = 'select-tipoAfectacion'

        if (vTipoAfectacion) {
          nextNodeId = 'select-centroCosto'

          if (vFlagCentroCosto) {
            if (vCentroCosto) {
              if (aplicaDestino) {
                if (vCuentaDestino) {
                  nextNodeId = 'nuevoasiento-agregar-button'
                } else {
                  nextNodeId = 'select-cuentaDestino'
                }
              } else {
                nextNodeId = 'nuevoasiento-agregar-button'
              }
            }
          } else {
            if (aplicaDestino) {
              if (vCuentaDestino) {
                nextNodeId = 'nuevoasiento-agregar-button'
              } else {
                nextNodeId = 'select-cuentaDestino'
              }
            } else {
              nextNodeId = 'nuevoasiento-agregar-button'
            }
          }
        }
      }

      KeyEventUtil.leaveOnEnterOrTab(nextNodeId, e)
    },
    [
      vCuentaContable,
      vTipoAfectacion,
      vFlagCentroCosto,
      vCentroCosto,
      vCuentaDestino,
      aplicaDestino
    ]
  )

  return (
    <Form.Group>
      <Form.Label text='IMPORTE' htmlFor='input-importe' md={5} />
      <Col md={7}>
        <Field name='noIncluyeIgv'>
          {({ field }) => (
            <Form.Checkbox {...field} id='check-masigv' label='NO INC IGV' checked={noIncluyeIgv} />
          )}
        </Field>
      </Col>
      <Col md={12}>
        <Field name='importe'>
          {({ field }) => (
            <Form.InputNumber
              {...field}
              ref={innerRef}
              id='input-importe'
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
              onKeyDown={onKeyDown}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(ImporteFormGroup)
